<template>
  <div class="calendar-stats">
    <div class="calendar-stats__month">{{ monthLabel }}</div>
    <div class="d-flex">
      <!-- Открытые интервалы -->
      <v-menu v-model="menus.slots" offset-y left :close-on-content-click="false" max-width="340">
        <template #activator="{ on, attrs }">
          <button type="button" class="calendar-stat" v-bind="attrs" v-on="on">
            <div class="calendar-stat__value">{{ summary.openSlots }}</div>
            <div class="calendar-stat__label">
              Открытых интервалов
              <v-icon x-small class="calendar-stat__hint">mdi-information-outline</v-icon>
            </div>
          </button>
        </template>
        <v-card class="stat-popover">
          <div class="stat-popover__title">Открытые интервалы · {{ monthLabel }}</div>
          <div class="stat-popover__text">
            Свободные окна экспертов, на которые клиенты ещё могут записаться. Прошедшие дни не учитываются.
            Одно окно может вместить несколько записей — это не количество свободных мест.
          </div>
          <div class="stat-popover__section">
            <div class="stat-popover__section-title">По экспертам</div>
            <div v-for="row in slotsByExpert" :key="row.label" class="stat-popover__row">
              <span class="text-truncate">{{ row.label }}</span>
              <span class="stat-popover__row-value">{{ row.value }}</span>
            </div>
            <div v-if="!slotsByExpert.length" class="stat-popover__note">В этом месяце свободных окон нет.</div>
          </div>
          <v-btn small text color="#483CB9" class="text-none px-0 mt-2" @click="emitAndClose('show-calendar')">
            Открыть календарь
            <v-icon small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
      </v-menu>

      <!-- Записи в месяце -->
      <v-menu v-model="menus.appointments" offset-y left :close-on-content-click="false" max-width="340">
        <template #activator="{ on, attrs }">
          <button type="button" class="calendar-stat" v-bind="attrs" v-on="on">
            <div class="calendar-stat__value">{{ summary.appointments }}</div>
            <div class="calendar-stat__label">
              Записей в месяце
              <v-icon x-small class="calendar-stat__hint">mdi-information-outline</v-icon>
            </div>
          </button>
        </template>
        <v-card class="stat-popover">
          <div class="stat-popover__title">Записи · {{ monthLabel }}</div>
          <div class="stat-popover__text">
            Все действующие записи с датой встречи в этом месяце: ожидающие подтверждения и подтверждённые.
          </div>
          <div class="stat-popover__section">
            <div class="stat-popover__section-title">По статусу</div>
            <div v-for="row in byStatus" :key="row.label" class="stat-popover__row">
              <span class="text-truncate">{{ row.label }}</span>
              <span class="stat-popover__row-value">{{ row.value }}</span>
            </div>

          </div>
          <div class="stat-popover__section">
            <div class="stat-popover__section-title">По экспертам</div>
            <div v-for="row in appointmentsByExpert" :key="row.label" class="stat-popover__row">
              <span class="text-truncate">{{ row.label }}</span>
              <span class="stat-popover__row-value">{{ row.value }}</span>
            </div>
            <div v-if="!appointmentsByExpert.length" class="stat-popover__note">Записей нет.</div>
          </div>
          <div v-if="summary.cancelledCount" class="stat-popover__note">
            Не входят: отклонённые и отменённые клиентом — {{ summary.cancelledCount }}.
          </div>
          <v-btn small text color="#483CB9" class="text-none px-0 mt-2" @click="emitAndClose('show-appointments', { status: 'active' })">
            Показать записи
            <v-icon small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
      </v-menu>

      <!-- Ожидают подтверждения -->
      <v-menu v-model="menus.pending" offset-y left :close-on-content-click="false" max-width="360">
        <template #activator="{ on, attrs }">
          <button type="button" :class="['calendar-stat', { 'calendar-stat--attention': summary.pending }]" v-bind="attrs" v-on="on">
            <div class="calendar-stat__value">{{ summary.pending }}</div>
            <div class="calendar-stat__label">
              Ожидают подтверждения
              <v-icon x-small class="calendar-stat__hint">mdi-information-outline</v-icon>
            </div>
          </button>
        </template>
        <v-card class="stat-popover">
          <div class="stat-popover__title">Ожидают подтверждения · {{ monthLabel }}</div>
          <div class="stat-popover__text">
            Заявки клиентов с датой встречи в этом месяце, которые эксперт ещё не подтвердил и не отклонил.
            Заявки, время которых уже прошло, не учитываются — их можно только отклонить.
          </div>
          <div v-if="!summary.pendingList.length" class="stat-popover__note">Все заявки этого месяца обработаны.</div>
          <div v-else class="stat-popover__list">
            <button
              v-for="item in nearestPending"
              :key="item.id"
              type="button"
              class="stat-popover__item"
              @click="emitAndClose('show-appointments', { status: 'pending', appointmentId: item.id })"
            >
              <span class="stat-popover__item-date">{{ formatStart(item) }}</span>
              <span class="stat-popover__item-name text-truncate">{{ guestName(item) }}</span>
              <span class="stat-popover__item-expert text-truncate">{{ expertName(item) }}</span>
            </button>
            <div v-if="summary.pendingList.length > nearestPending.length" class="stat-popover__note">
              и ещё {{ summary.pendingList.length - nearestPending.length }}
            </div>
          </div>
          <v-btn
            v-if="summary.pendingList.length"
            small
            text
            color="#483CB9"
            class="text-none px-0 mt-2"
            @click="emitAndClose('show-appointments', { status: 'pending' })"
          >
            Показать все
            <v-icon small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { utcToLocalTime } from '@/common/calendarTime';
import {
  appointmentExpertId, expertFullName, guestFullName,
} from './appointmentHelpers';

export default {
  name: 'CalendarStats',
  props: {
    month: { type: String, required: true }, // YYYY-MM
    summary: { type: Object, required: true },
    experts: { type: Array, default: () => [] },
    services: { type: Array, default: () => [] },
  },
  data() {
    return {
      menus: { slots: false, appointments: false, pending: false },
    };
  },
  computed: {
    monthLabel() {
      const label = this.$moment(this.month, 'YYYY-MM').locale('ru').format('MMMM YYYY');
      return label.charAt(0).toUpperCase() + label.slice(1);
    },
    byStatus() {
      const { appointments, pending, expired } = this.summary;
      return [
        { label: 'Ожидают подтверждения', value: pending },
        ...(expired ? [{ label: 'Просрочены (не подтверждены)', value: expired }] : []),
        { label: 'Подтверждены', value: appointments - pending - expired },
      ];
    },
    slotsByExpert() {
      return this.countByExpert(this.summary.openSlotsList.map((item) => item.expert));
    },
    appointmentsByExpert() {
      return this.countByExpert(this.summary.appointmentsList.map((item) => appointmentExpertId(item, this.services)));
    },
    nearestPending() {
      return this.summary.pendingList.slice(0, 5);
    },
  },
  methods: {
    emitAndClose(event, payload) {
      this.menus = { slots: false, appointments: false, pending: false };
      this.$emit(event, payload);
    },
    expertNameById(id) {
      return expertFullName(this.experts.find((expert) => expert.id === id)) || 'Без эксперта';
    },
    expertName(appointment) {
      return this.expertNameById(appointmentExpertId(appointment, this.services));
    },
    // Строки «эксперт — количество», по убыванию.
    countByExpert(expertIds) {
      const counts = {};
      expertIds.forEach((id) => {
        const name = this.expertNameById(id);
        counts[name] = (counts[name] || 0) + 1;
      });
      return Object.entries(counts)
        .map(([label, value]) => ({ label, value }))
        .sort((a, b) => b.value - a.value || a.label.localeCompare(b.label));
    },
    guestName(item) {
      return guestFullName(item) || item.guest_email || 'Клиент';
    },
    formatStart(item) {
      const date = this.$moment.utc(item.scheduled_starts_at).local().locale('ru').format('D MMM');
      return `${date}, ${utcToLocalTime(item.scheduled_starts_at)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_tokens.scss';

.calendar-stats__month {
  font-size: 11px;
  color: #8a8f9c;
  text-align: right;
  margin-bottom: 2px;
}

.calendar-stat {
  text-align: center;
  padding: 4px 10px;
  margin-left: 8px;
  border-radius: $radius-sm;
  transition: background-color $transition-fast;

  &:hover, &:focus-visible {
    background: rgba(72, 60, 185, 0.06);
    outline: none;
  }

  &__value {
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
  }

  &__label {
    font-size: 12px;
    color: #8a8f9c;
    white-space: nowrap;
  }

  &__hint {
    color: #b0b4be !important;
    vertical-align: baseline;
  }

  &--attention &__value {
    color: #B26A00;
  }
}

.stat-popover {
  padding: $space-4;
  font-size: $text-sm;

  &__title {
    font-weight: $weight-semibold;
    font-size: $text-md;
    margin-bottom: $space-2;
  }

  &__text {
    color: #5f6472;
    line-height: 1.4;
  }

  &__section {
    margin-top: $space-3;
  }

  &__section-title {
    font-size: 11px;
    font-weight: $weight-semibold;
    color: #8a8f9c;
    text-transform: uppercase;
    margin-bottom: $space-1;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    gap: $space-3;
    padding: 2px 0;
  }

  &__row-value {
    font-weight: $weight-semibold;
  }

  &__note {
    margin-top: $space-2;
    color: #8a8f9c;
    font-size: $text-xs;
  }

  &__list {
    margin-top: $space-3;
  }

  &__item {
    display: grid;
    grid-template-columns: 92px 1fr;
    column-gap: $space-2;
    width: 100%;
    text-align: left;
    padding: 6px $space-2;
    border-radius: $radius-xs;

    &:hover {
      background: #fff4e0;
    }
  }

  &__item-date {
    grid-row: span 2;
    font-weight: $weight-medium;
    color: #B26A00;
  }

  &__item-expert {
    font-size: $text-xs;
    color: #8a8f9c;
  }
}
</style>
